import { FormContext, SharedFormValidation } from "../models";

export const getNewFormContext = (): FormContext => {
  return {
    sharedValidation: new SharedFormValidation(),
    submitValidationEnabled: false,
  };
};
